export const courierCodeMap = {
  "우체국택배": "01",
  "CJ대한통운": "04",
  "한진택배": "05",
  "로젠택배": "06",
  "롯데택배": "08",
  "일양로지스": "11",
  "EMS": "12",
  "DHL": "13",
  "UPS": "14",
  "한의사랑택배": "16",
  "천일택배": "17",
  "건영택배": "18",
  "한진택배B2B": "20",
  "Fedex": "21",
  "대신택배": "22",
  "경동택배": "23",
  "GS Postbox 택배": "24",
  "TNT Express": "25",
  "USPS": "26",
  "GSMNtoN": "28",
  "KGL네트웍스": "30",
  "합동택배": "32",
  "LX판토스": "37",
  "ECMS Express": "38",
  "GSI Express": "41",
  "CJ대한통운 국제특송": "42",
  "애니트랙": "43",
  "SLX택배": "44",
  "우리택배(구호남택배)": "45",
  "CU편의점택배": "46",
  "우리한방택배": "47",
  "ACI Express": "48",
  "A.C.E EXPRESS INC": "49",
  "GPS Logix": "50",
  "성원글로벌카고": "51",
  "농협택배": "53",
  "홈픽택배": "54",
  "EuroParcel": "55",
  "YJS글로벌(영국)": "60",
  "은하쉬핑": "63",
  "YJS글로벌(월드)": "65",
  "Giant Network Group": "66",
  "대림통운": "69",
  "LOTOS CORPORATION": "70",
  "IK물류": "71",
  "성훈물류": "72",
  "CR로지텍": "73",
  "용마로지스": "74",
  "원더스퀵": "75",
  "LineExpress": "77",
  "제니엘시스템": "81",
  "컬리넥스트마일": "82",
  "스마트로지스": "84",
  "풀앳홈": "85",
  "이투마스(ETOMARS)": "87",
  "두발히어로": "89",
  "위니아딤채": "90",
  "하이브시티": "91",
  "지니고 당일배송": "92",
  "팬스타국제특송(PIEX)": "93",
  "카카오 T 당일배송": "94",
  "트랙스로지스": "95",
  "에이씨티앤코아물류": "97",
  "롯데택배 해외특송": "99",
  "나은물류": "100",
  "한샘서비스": "101",
  "SHIPNERGY": "102",
  "도도플렉스(dodoflex)": "104",
  "브릿지로지스㈜": "105",
  "LG전자": "107",
  "MEXGLOBAL": "108",
  "1004홈": "112",
  "썬더히어로": "113",
  "캐나다쉬핑": "114",
  "YUNDA EXPRESS": "117",
  "롯데칠성": "118",
  "핑퐁": "119",
  "발렉스 특수물류": "120",
  "바바바(bababa)": "121",
  "BAIMA EXPRESS": "122",
  "엔티엘피스": "123",
  "LTL": "124",
  "지케이글로벌": "125",
  "로지스팟": "127",
  "판월드로지스틱": "128",
  "홈픽 오늘도착": "129",
  "로지스파트너": "130",
  "딜리래빗": "131",
  "지오피": "132",
  "에이치케이홀딩스": "134",
  "HTNS": "135",
  "케이제이티": "136",
  "더바오": "137",
  "라스트마일": "138",
  "직구문": "140",
  "인터로지스": "141",
  "탱고앤고": "142",
  "투데이": "143",
  "큐브플로우(CUBEFLOW)": "144",
  "현대글로비스": "145",
  "국제로지스틱(KSE)": "146",
  "에스더쉬핑": "147",
  "ARGO(테크타카)": "148",
  "골드스넵스": "149",
  "자이언트": "151",
  "엠티인터내셔널": "152",
  "이지로지스틱": "153",
  "케이티익스프레스": "154",
  "HY": "155",
  "유피로지스(제주)": "156",
  "반얀로지스틱스": "157",
  "AusPost": "158",
  "삼다수 가정배송": "159",
  "와이드테크": "160",
  "SAP EXPRESS": "162",
  "위니온": "163",
  "서림특송": "165",
  "Rincos": "166",
  "딜리박스": "167",
  "이스트라": "168",
  "JNT": "169",
  "유피로지스": "170",
  "올인닷컴": "171",
  "물류대장(택배)": "173",
  "풀무원샘물㈜": "175",
  "티에스지로지스": "177",
  "SLO(모든)": "179",
  "지씨에스": "182",
  "바로스": "183",
  "윤익스프레스(YunExpress)": "185",
  "레터스": "186",
  "벤더피아": "187",
  "CXCExpress": "188",
  "세븐일레븐 착한택배": "189",
  "물류대장(설치)": "190",
};

export const courierOptions = Object.keys(courierCodeMap);

export const getCourierCode = (courierName) => {
  return courierCodeMap[courierName] || "";
};
